import {
    whiteColor,
    boxShadow,
} from '../global';

const userLoginStyle = (theme) => ({
    wrapper: {
        width: '100%',
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    mainBox: {
        [theme.breakpoints.up('md')]: {
            margin: 'auto',
            width: '70%',
            display: 'flex',
            justifyContent: 'center',
        },
    },
    input: {
        margin: 0,
    },
    linkRegister: {
        textAlign: 'right',
    },
    item: {
        margin: '10px 0 0 0',
    },
    background: {
        minHeight: '576px',
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: whiteColor,
        display: 'flex',
        borderRadius: '8px',
        [theme.breakpoints.down('md')]: {
            minHeight: '465px',
        },
        ...boxShadow,
    },
    backgroundLoginViewer: {
        minHeight: '576px',
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: (props) => props?.eventInfo?.settings_colors_viewer?.screen_background_color,
        display: 'flex',
        borderRadius: '8px',
        [theme.breakpoints.down('md')]: {
            minHeight: '465px',
        },
        ...boxShadow,
    },
    box: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100%',
        width: '85%',
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    colorTextInput: {
        '& input': {
            color: '#4b4b4b',
        },
        '& > div': {
            backgroundColor: whiteColor,
        },
        '& label.Mui-focused': {
            color: '#4b4b4b',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#4b4b4b',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#4b4b4b',
            },
        },
    },
});

export default userLoginStyle;
